import React, { useState, useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Collapse } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import {
  ExpandLessRounded as UpIcon,
  ExpandMoreRounded as DownIcon,
} from '@material-ui/icons'

import { objLength } from '../../../utils/customMethods'

import { getChatInfo } from '../../../utils/chatInfo'
import Insights from './Insights'
import GeneralInformation from './GeneralInformation'
import UsefulLinks from './UsefulLinks'
import HistoryConversationBookmark from './historyBookmark'
import Typography from '../../atoms/display/typography'

import useStyles from './historyNotesStyle'

const HistoryNotes = (props) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const theme = useTheme()
  const dispatch = useDispatch()

  const generalInformation = useSelector((state) => state.generalInformation)

  const [expanded, setExpanded] = useState({
    0: true,
    1: true,
    2: true,
    3: true,
  })

  const handleCollapse = useCallback((index) => {
    setExpanded((expanded) => ({
      ...expanded,
      [index]: expanded[index] === true ? false : true,
    }))
  }, [])

  const renderContent = () => {
    const chatId = props?.chatId

    if (chatId) {
      return (
        <>
          <div className={classes.menuBar} onClick={() => handleCollapse(0)}>
            <Typography variant="body1">
              {t('commons.wordsCollectedInConversation')}
            </Typography>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              {expanded[0] ? (
                <UpIcon
                  style={{ marginLeft: 10, color: theme.palette.primary.main }}
                />
              ) : (
                <DownIcon
                  style={{ marginLeft: 10, color: theme.palette.primary.main }}
                />
              )}
            </div>
          </div>
          <Collapse in={expanded[0]} unmountOnExit>
            <Insights
              chatId={props?.chatId}
              consumerId={props?.consumerId}
              isHistoryNotes={props?.isHistoryNotes}
            />
          </Collapse>
          <div className={classes.menuBar} onClick={() => handleCollapse(1)}>
            <Typography variant="body1">
              {t('commons.favoriteMessages')}
            </Typography>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              {expanded[1] ? (
                <UpIcon
                  style={{ marginLeft: 10, color: theme.palette.primary.main }}
                />
              ) : (
                <DownIcon
                  style={{ marginLeft: 10, color: theme.palette.primary.main }}
                />
              )}
            </div>
          </div>
          <Collapse in={expanded[1]} timeout="auto" unmountOnExit>
            <HistoryConversationBookmark
              chatId={props?.chatId}
              consumerId={props?.consumerId}
              isHistoryNotes={props?.isHistoryNotes}
            />
          </Collapse>
          <div className={classes.menuBar} onClick={() => handleCollapse(2)}>
            <Typography variant="body1">{t('commons.usefulLinks')}</Typography>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              {expanded[2] ? (
                <UpIcon
                  style={{ marginLeft: 10, color: theme.palette.primary.main }}
                />
              ) : (
                <DownIcon
                  style={{ marginLeft: 10, color: theme.palette.primary.main }}
                />
              )}
            </div>
          </div>
          <Collapse in={expanded[2]} timeout="auto" unmountOnExit>
            <UsefulLinks
              chatId={props?.chatId}
              isHistory={props?.isHistoryNotes}
            />
          </Collapse>
          <div className={classes.menuBar} onClick={() => handleCollapse(3)}>
            <Typography variant="body1">
              {t('commons.generalInformation')}
            </Typography>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              {expanded[3] ? (
                <UpIcon
                  style={{ marginLeft: 10, color: theme.palette.primary.main }}
                />
              ) : (
                <DownIcon
                  style={{ marginLeft: 10, color: theme.palette.primary.main }}
                />
              )}
            </div>
          </div>
          <Collapse in={expanded[3]} timeout="auto" unmountOnExit>
            <GeneralInformation
              chatId={props?.chatId}
              isHistory={props?.isHistoryNotes}
            />
          </Collapse>
        </>
      )
    }
  }

  useEffect(() => {
    const chatId = props?.chatId
    if (
      chatId &&
      !objLength(generalInformation.conversations[chatId]) > 0 &&
      !generalInformation?.status?.get_general_info?.loading
    ) {
      getChatInfo(chatId, dispatch)
    }
  }, [props?.chatId])

  return (
    <>
      <div className={classes.root}>{renderContent()}</div>
    </>
  )
}

export default HistoryNotes
